import { Theme, ThemeProvider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { customColorType, customNavMode, customThemeMode } from "./custom.types";
import { getCustomTheme } from "./schemes/CustomTheme";
import * as moment from 'moment';

import 'moment/locale/tr';
import 'moment/locale/az';
import 'moment/locale/ru';
import 'moment/locale/fr';
import 'moment/locale/uz';
import 'moment/locale/es-us';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider, trTR, enUS, frFR } from '@mui/x-date-pickers';
import { useAppSelector } from "src/store";
interface CustomThemeContextState {
    color: customColorType;
    setColor: (value: customColorType) => void;
    mode: customThemeMode;
    setMode: (value: customThemeMode) => void;
    navMode: customNavMode;
    setNavMode: (value: customNavMode) => void;
    lang: string;
    setLang: (value: string) => void;
}
export const CustomThemeContext = React.createContext<CustomThemeContextState>({
    color: null,
    setColor: (value) => { },
    mode: null,
    setMode: (value) => { },
    navMode: null,
    setNavMode: (value) => { },
    lang: null,
    setLang: (value) => { },
});
const CustomThemeProvider = (props): JSX.Element => {
    const [color, setColor] = useState<customColorType>(localStorage.getItem("themeColor") ? localStorage.getItem("themeColor") as any : "blue")
    const [mode, setMode] = useState<customThemeMode>(localStorage.getItem("themeMode") ? localStorage.getItem("themeMode") as any : "light")
    const [navMode, setNavMode] = useState<customNavMode>(localStorage.getItem("themeNavMode") ? localStorage.getItem("themeNavMode") as any : "white")
    const [lang, setLang] = useState(localStorage.getItem("lang"))
    const formSize = useAppSelector(s=> s.userLogin.formSize)
    const [theme, setTheme] = useState<Theme>(getCustomTheme("blue", "light", lang, formSize))
    const [dpLocale, setDpLocale] = useState("")
    const [localeText, setLocaleText] = useState(null)
    useEffect(() => {
        localStorage.setItem("themeNavMode", navMode)
        localStorage.setItem("themeMode", mode)
        localStorage.setItem("themeColor", color)
        setTheme(getCustomTheme(color, mode, lang, formSize))
        let langObject = moment.locale("tr");
        let langText = trTR.components.MuiLocalizationProvider.defaultProps.localeText;
        switch (lang) {
            case "AZ":
                langText = trTR.components.MuiLocalizationProvider.defaultProps.localeText;
                langObject = moment.locale("az");
                break;
            case 'US':
                langText = enUS.components.MuiLocalizationProvider.defaultProps.localeText;
                langObject = moment.locale("esUs");
                break;
            case "RU":
                langObject = moment.locale("ru");
                break;
            case "UZ":
                langObject = moment.locale("uz");
                break;
            case 'FR':
                langText = frFR.components.MuiLocalizationProvider.defaultProps.localeText;
                langObject = moment.locale("fr");
                break;
        }
        setDpLocale(langObject)
        setLocaleText(langText)
    }, [color, mode, navMode, lang, formSize])

    return (
        <CustomThemeContext.Provider
            value={{
                color,
                setColor,
                mode,
                setMode,
                navMode,
                setNavMode,
                lang,
                setLang
            }}
        >
            <ThemeProvider theme={theme}>
                <LocalizationProvider
                    dateAdapter={AdapterMoment}
                    adapterLocale={dpLocale}
                    localeText={localeText}>
                    {props.children}
                </LocalizationProvider>
            </ThemeProvider>

        </CustomThemeContext.Provider>
    )
}
export default CustomThemeProvider;